import WinnersActionTypes from './types';

const initialState = {
  winners: [],
  hasNextPage: false,
  currentPage: 1,
  pageSize: 100,
  winnerGifts: [],
  couponCode: null,
  searchQuery: '',
  isFetchingWinners: false,
  isSearchingWinners: false,
  isSearchingCouponCode: false,
  isUpdatingCouponCode: false,
  isFetchingWinnerGifts: false,
  isClaimingGift: false,
  hasClaimedGift: false,
};

const winnerReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case WinnersActionTypes.FETCH_WINNERS_SUCCESS: {
      return { ...state, winners: payload };
    }
    case WinnersActionTypes.SET_WINNER_STATE: {
      return { ...state, ...payload };
    }
    default: {
      return state;
    }
  }
};

export default winnerReducer;
